const css = `.UPzRDG__copyBtn{width:100%;height:100%}.UPzRDG__copyBtn:hover span,.UPzRDG__copyBtn:focus span,.UPzRDG__copyBtn:active span{text-decoration:none!important}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"copyBtn":"UPzRDG__copyBtn"};
